import { Component, OnInit,ChangeDetectorRef  } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { filter, map, pluck } from 'rxjs/operators';
import { VtigerService } from './api/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  sessionid?: string;
  appPages?: any;
  modules?: any;
  labels?: any;
  public firstname?: any;
  public lastname?: any;
  public email?: any;
  public usuario: any;
  public label: any;
  esEspanol = false;
  message$: Observable<string>;

  currentLanguage = 'es'; // Establece el idioma predeterminado como español
  esButtonDisabled = false;
  enButtonDisabled = true;
  tipoLead: any;
  constructor(private cdr: ChangeDetectorRef,private location: Location, private translate: TranslateService, private storageService: StorageService, private menu: MenuController, private http: HttpClient, private ws: VtigerService, public route: ActivatedRoute, public router: Router) {
    translate.setDefaultLang('en');
    translate.use('en');
    // Recuperar el idioma desde localStorage
    const idioma = localStorage.getItem('idioma');

    if (idioma === 'Ingles') {
      // Configura el idioma en inglés
      this.translate.use('en');
      this.currentLanguage = 'en'; // Actualiza la variable de idioma
    } else {
      // Configura el idioma en español
      this.translate.use('es');
      this.currentLanguage = 'es'; // Actualiza la variable de idioma
    }
    this.openFirst();
  }

  async ngOnInit() {
    const currentUrl = window.location.protocol + '//' + window.location.host + this.location.path();
    this.tipoLead = localStorage.getItem('ledtipo') == 'Postulante' ? true : false
  //   if (currentUrl.includes("proyectosinversion")) {
  //     this.translate.use("es");
  //     this.esEspanol = true;
  //  //   this.changeLanguage('en');
  //   }
  //   else{
  //     this.translate.use("en");
  //   //  this.changeLanguage('en');
  //   }


      
    if (localStorage.getItem('sessionid')) {
      this.usuario = JSON.parse(localStorage.getItem('usuarioLogueado'))
      console.log(this.usuario['first_name'])
      console.log(this.usuario['last_name']);
      if (this.usuario != undefined) {
        this.firstname = this.usuario['first_name']
        this.lastname = this.usuario['last_name']
        this.email = this.usuario['email']
      }
    }


    this.message$ = this.storageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === "message"),
      pluck("value")
    );

  }
  // toggleLanguage() {
  //   // Cambiar el idioma y almacenar en localStorage
  //   if (this.currentLanguage === 'en') {
  //     this.translate.use('es');
  //     localStorage.setItem('idioma', 'Espaniol');
  //     this.currentLanguage = 'es'; // Actualiza la variable de idioma
  //   } else {
  //     this.translate.use('en');
  //     localStorage.setItem('idioma', 'Ingles');
  //     this.currentLanguage = 'en'; // Actualiza la variable de idioma
  //   }

  //   // Recargar la página para aplicar el cambio de idioma
  //   window.location.reload();
  // }
  changeLanguageAll(lang: string) {
    // Cambiar el idioma y almacenar en localStorage
    console.log("Este es el idioma ->" + lang);
    if (lang === 'en') {
      this.translate.use('en');
      localStorage.setItem('idioma', 'Ingles');
      this.currentLanguage = 'en'; // Actualizar el estado del idioma actual
    } else {
      this.translate.use('es');
      localStorage.setItem('idioma', 'Español');
      this.currentLanguage = 'es'; // Actualizar el estado del idioma actual
    }
  }
  
  tieneSesion() {

    if (localStorage.getItem('sessionid')) {
      return true;
    } else {
      return false;
    }
  }


  async getRecord(id: string) {

    var record = await this.ws.getUsers(id)
    return record['result']
  }

  openFirst() {
    this.menu.enable(true, 'first');
    this.menu.open('first');
    this.http.get('assets/json/labels.json').pipe(
      map((res: any) => {
        return res;
      })
    ).subscribe((val) => { this.labels = val });
  }

  async onMenuWillOpen() {
    this.sessionid = localStorage.getItem('sessionid');
    if (!this.sessionid) {
      localStorage.clear();
      this.appPages = this.labels.unlogged;
    } else
      await this.ws.testSession().then(async (res: any) => {
        if (!res || !res.success) {
          localStorage.clear();
          this.modules = null;
          this.onMenuWillOpen();
          this.router.navigate(['/login']);
        } else {
          if (!this.modules) {
            this.appPages = this.labels.logged;
            await this.ws.describeModules().then((response: any) => {
              if (response.success) {
                var modulos = Array();
                localStorage.setItem('modulemodels', JSON.stringify(response.result));
                for (var m in response.result) {
                  var l = response.labels[m];
                  if (!l) continue;
                  l.name = m;
                  modulos.push(l);
                }
                this.modules = modulos;
              }
            }
            );
          }
        }
      });
  }

  logout() {
    localStorage.clear();
    this.modules = null;
    this.onMenuWillOpen();
    this.storageService.setStorageItem({
      key: "message",
      value: "Iniciar Sesión",
      storageArea: "sessionStorage"
    });
    this.router.navigate(['/login']);

  }
}
